module.exports = __webpack_public_path__ + "img/color-1@2x.5611f10.webp";